import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsibilityManager } from '../components/ResponsibilityManager';
import '../styles/task-responsibilities.css';

interface TaskResponsibilitiesTabProps {
  onHasChangesChange?: (hasChanges: boolean) => void;
}

const TaskResponsibilitiesTab: React.FC<TaskResponsibilitiesTabProps> = ({ onHasChangesChange }) => {
  const { t } = useTranslation();

  return (
    <div className="task-responsibilities-tab-container">
      {/* Header */}
      <div className="task-responsibilities-header">
        <div className="task-responsibilities-header-content">
          <div className="task-responsibilities-title-row">
            <div>
              <h2 className="task-responsibilities-title">
                {t('admin.userManagement.responsibilities.title', 'Responsabilités des Tâches')}
              </h2>
              <p className="task-responsibilities-subtitle">
                {t(
                  'admin.userManagement.responsibilities.subtitle',
                  'Configurez les utilisateurs responsables des affaires et leur disponibilité hebdomadaire'
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="task-responsibilities-content">
        <ResponsibilityManager onHasChangesChange={onHasChangesChange} />
      </div>
    </div>
  );
};

export { TaskResponsibilitiesTab };
export default TaskResponsibilitiesTab;
